/**
 * TanStack Query hooks for `advertiser-api` keys.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	advertiserApiQueryKeys,
	type CreateAdvertiserApiKeyBody,
	type CreateAdvertiserApiKeyResponse,
	type ListAdvertiserApiKeysResponse,
} from "./api";

export function useAdvertiserApiList(): UseQueryResult<
	ListAdvertiserApiKeysResponse,
	Error
> {
	return useQuery({
		queryKey: advertiserApiQueryKeys.list(),
		queryFn: list,
	});
}

export function useAdvertiserApiCreate(): UseMutationResult<
	CreateAdvertiserApiKeyResponse,
	Error,
	CreateAdvertiserApiKeyBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: advertiserApiQueryKeys.all });
		},
	});
}

export function useAdvertiserApiDelete(): UseMutationResult<
	{ removed: boolean },
	Error,
	string
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: advertiserApiQueryKeys.all });
		},
	});
}
